import React from "react";
import PropTypes from "prop-types";

import colors from "core/colors";
import {
    CardTitle,
    CardHighlightsContainer,
    CardHighlight,
    CardCta,
    CardIconContainer,
    CardMobileContentContainer
} from "core/Card";
import {
    StyledHeroCard,
    HeroCardDescription,
    HeroCardNonMobileContentContainer
} from "./styles";

const HeroCard = ({ icon, title, description, highlights, sectionId }) => {
    const Icon = icon;
    const cardIconSection = (
        <CardIconContainer>
            <Icon fillColor={colors.midnight} size="xl" />
        </CardIconContainer>
    );
    const cardTitle = (
        <CardTitle type="h5" size="sm" alignment="center">
            {title}
        </CardTitle>
    );
    const cardDescription = (
        <HeroCardDescription>{description}</HeroCardDescription>
    );
    const cardHighlights = (
        <CardHighlightsContainer>
            {highlights.map(highlight => (
                <CardHighlight key={highlight[1]}>{highlight[0]}</CardHighlight>
            ))}
        </CardHighlightsContainer>
    );
    const cardCta = <CardCta href={`#${sectionId}`}>Learn More</CardCta>;

    const nonMobileCard = (
        <HeroCardNonMobileContentContainer>
            {cardIconSection}
            {cardTitle}
            {cardDescription}
            {cardHighlights}
            {cardCta}
        </HeroCardNonMobileContentContainer>
    );

    const mobileCard = (
        <CardMobileContentContainer>
            {cardIconSection}
            <div>
                {cardTitle}
                {cardCta}
            </div>
        </CardMobileContentContainer>
    );

    return (
        <StyledHeroCard>
            {mobileCard}
            {nonMobileCard}
        </StyledHeroCard>
    );
};

HeroCard.propTypes = {
    icon: PropTypes.object,
    title: PropTypes.string,
    description: PropTypes.string,
    highlights: PropTypes.array,
    sectionId: PropTypes.string
};

export default HeroCard;
